import { createContext, type ReactNode } from "react";

import { useAnalyticsContext } from "common/core/manage_analytics_context";
import type { OrganizationMembershipRole } from "graphql_globals";

type ProviderProps = {
  children: ReactNode;
  viewer: {
    user: null | {
      organizationMembership: null | {
        role: OrganizationMembershipRole;
      };
    };
  };
};
type Context = null | OrganizationMembershipRole;

const OrgRoleContext = createContext<Context>(null);

function getValue({ user }: ProviderProps["viewer"]): Context {
  return user?.organizationMembership?.role || null;
}

function OrganizationRoleProvider({ children, viewer }: ProviderProps) {
  return <OrgRoleContext.Provider value={getValue(viewer)}>{children}</OrgRoleContext.Provider>;
}

export default function OrganizationRoleProviderWithAnalytics(props: ProviderProps) {
  useAnalyticsContext(() => ({
    business_role: getValue(props.viewer),
  }));
  return <OrganizationRoleProvider {...props} />;
}
